<template>
      <div class="detail_page">
        <div class="top">
            <v-row>
                <v-col sm="12" md="2">
                    <div class="back hand" @click="goBack"><v-icon>mdi-arrow-left</v-icon><span class="text">{{detailInfo.name}}</span></div>
                    <!-- <div class="detail_tit">石墨烯</div> -->
                    <!-- <v-divider></v-divider> -->
                </v-col>
                <v-col sm="12" md="10">
                    <div class="flex_style right" style="height: 100%;" v-if="false">
                        <div class="menu_icon hand" title="分享给你的同事吧">
                            <span class="hidden-sm-and-down">分享给你的同事吧</span>
                            <v-icon>mdi-share-variant</v-icon>
                        </div>
                        <div class="menu_icon hand" title="设置" @click="setShow"><v-icon>mdi-cog</v-icon></div>
                    </div>
                </v-col>
            </v-row>
           
        </div>
        <v-row>
            <v-col sm="12" md="2" class="space_left border-right workdetail">
                <div class="space_menu">
                    <div class="left_side folder_side_wrapper">
                        <v-row>
                            <v-col>
                                <v-tabs background-color='#f2f5fa' show-arrows>
                                    <v-tab key="1">文件夹</v-tab>
                                    <v-tab key="2">过滤</v-tab>
                                    <!-- <v-tab key="3">分析</v-tab> -->
                                    <v-tab-item key="1">
                                    <folderSide></folderSide>
                                    </v-tab-item>
                                    <v-tab-item key="2">
                                        <filterSide :folderId="folderId" @filterChange="filterChange" @secondFilter="secondFilter"></filterSide>
                                    </v-tab-item>
                                    <!-- <v-tab-item key="3" class="tab_content">
                                        <analySide></analySide>
                                    </v-tab-item> -->
                                </v-tabs>
                            </v-col>
                        </v-row>
                    </div>
                    <!-- <leftSide :folderId="folderId" @filterChange="filterChange"></leftSide> -->
                </div>
            </v-col>
            <v-col sm="12" md="10" class="space_right">
                <v-row>
                    <v-col sm="12" md="8">
                        <div class="flex_style left">
                            <div class="menu_icon hand" :class="{'active': showList.tables}" title="表格展示" @click="changeShow('tables')"><v-icon>mdi-table</v-icon></div>
                            <div class="menu_icon hand" :class="{'active': showList.imageText}" title="图文展示"  @click="changeShow('imageText')"><v-icon>mdi-format-list-text</v-icon></div>
                            <div class="menu_icon hand" :class="{'active': showList.fullText}" title="全文附图"  @click="changeShow('fullText')"><v-icon>mdi-folder-image</v-icon></div>
                            <div class="menu_icon input_style" v-if="contents"> 
                                <v-select
                                :items="items"
                                label="排序"
                                outlined
                                v-model="sortKey"
                                item-text="key"
                                item-value="value"
                                @change="sortChange"
                                ></v-select>
                            </div>
                            <div class="menu_icon input_style">
                                <v-select
                                    :items="items1"
                                    label="分析"
                                    outlined
                                    v-model="analyKey"
                                    @change="analyChange"
                                    ></v-select>
                            </div>
                            <div class="menu_icon hidden-sm-and-down" v-if="false"><v-btn depressed>导出</v-btn></div>
                            <div class="menu_icon hidden-sm-and-down" v-if="false&&contents"><v-btn depressed>导入</v-btn></div>
                        </div>
                    </v-col>
                    <v-col sm="12" md="4" v-if="false&&contents">
                        <div class="flex_style right">
                            <div class="menu_icon">
                                <v-btn depressed>自动收录</v-btn>
                            </div>
                            <div class="menu_icon">
                                <v-btn depressed>自定义字段</v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <contents v-if="contents&&data" :showList="showList" :result="data" :fid="folderId"></contents>
                <v-row>
                    <v-col class="common_page">
                        <span class="text hidden-xs-only">共{{total}}条记录</span>
                        <v-pagination
                            v-model="currentPage"
                            :length="length"
                            :total-visible="7"
                            >
                        </v-pagination>
                    </v-col>
                </v-row>
                <!-- <analysis v-if="analysis"></analysis> -->
            </v-col>
        </v-row>
         <v-dialog
            v-model="dialog"
            width="500">
            <v-card>
                <v-card-title class="headline lighten-2">页面设置</v-card-title>
                <v-card-text>
                    <v-tabs>
                        <v-tab key="1">分析概览</v-tab>
                        <v-tab key="2">搜索全局设置</v-tab>
                        <v-tab-item key="1">
                            <div class="flex_style left shuttle_wrapper">
                                <div class="item">
                                    <div>可选图表</div>
                                    <ul>
                                        <li class="hand" v-for="(item,index) in chatNameList" @click="move(item)" :key="index">{{item.name}}</li>
                                    </ul>
                                </div>
                                <div class="item">
                                    <div>显示图表</div>
                                    <ul>
                                        <li class="hand" v-for="(item,index) in chatNameList1" @click="move1(item)" :key="index">{{item.name}}</li>
                                    </ul>
                                </div>
                            </div>
                        </v-tab-item>
                        <v-tab-item key="2">
                            <div style="padding: 24px;">
                                <v-radio-group v-model="radioGroup">
                                    <v-radio
                                        v-for="(item, index) in radioList"
                                        :key="index"
                                        :label="`${item.name}`"
                                        :value="item.key"
                                    ></v-radio>
                                </v-radio-group>
                            </div>
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="dialog = false">
                    取消
                </v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="dialog = false">
                    确定
                </v-btn>
                </v-card-actions>
            </v-card>
         </v-dialog>
      </div>
</template>
<script>
// import leftSide from "@/components/side/leftSide.vue";
import contents from "@/components/side/content.vue";
import analysis from "@/components/side/analysis.vue";
import filterSide from "@/components/space/filterSide.vue";
import folderSide from '@/components/side/folderSide.vue'
import {mapActions} from 'vuex'
import Qs from 'qs'
export default {
    data() {
        return {
            id: '',
            detailInfo: {},
            items: [
                {
                    key: '↓ 添加顺序',
                    value: 'add!',
                },
                {
                    key: '↑ 添加顺序',
                    value: 'add',
                },
                {
                    key: '↓ 申请日期',
                    value: 'ad!',
                },
                {
                    key: '↓ 申请日期',
                    value: 'ad',
                },
                {
                    key: '↓ 公开/公告日',
                    value: 'dd!',
                },
                {
                    key: '↓ 公开/公告日',
                    value: 'dd',
                },
                {
                    key: '↓ 专利评级',
                    value: 'rank!',
                },
            ],
            sortKey: '',
            // items1: ['专利分析','3D专利地图分析','矩阵分析'],
            items1: ['专利分析'],
            contents: true,
            analysis: false,
            showList: {
                'tables': true,
                'analysis': false,
                'imageText': false,
                'fullText': false
            },
            analyKey: '',
            dialog: false,
            chatNameList1: [],
            chatNameList: [
                {
                    key: 'fterm',
                    name: 'F-Term完成码排名'
                },
                 {
                    key: 'applyer',
                    name: '[标]当前申请（专利权）人排名'
                },
                 {
                    key: 'applyer1',
                    name: '[标]原始申请（专利权）人排名'
                },
                 {
                    key: 'applyer2',
                    name: '原始申请（专利权）人排名'
                },
                 {
                    key: 'docdb',
                    name: 'Docdb申请（专利权）人排名'
                },
                 {
                    key: 'inventor',
                    name: '发明人排名'
                },
                 {
                    key: 'agency',
                    name: '代理机构排名'
                },
                 {
                    key: 'agent',
                    name: '代理人排名'
                },
                 {
                    key: 'open_trend',
                    name: '公开趋势'
                },
                 {
                    key: 'apply_trend',
                    name: '申请趋势'
                },
                 {
                    key: 'ipc',
                    name: 'IPC分类排名'
                },
                {
                    key: 'curapply',
                    name: '当前申请（专利权）人排名'
                },
                {
                    key: 'cpc',
                    name: 'CPC分类排名'
                }
            ],
            radioGroup: '',
            radioList: [
                {
                    key: 'all',
                    name: '所有搜索结果（不分组）'
                },
                 {
                    key: 'every1',
                    name: '每件申请显示一个公开文本'
                },
                 {
                    key: 'every2',
                    name: '每组简单同族一个专利代表'
                },
                 {
                    key: 'every3',
                    name: '每组IPNPADOC同族一个专利代表'
                }
            ],
            data: [],
            fcKey: [],
            currentPage: 1,
            pageSize: 30,
            total: 0,
            length: 0,
            q2: ''
        }
    },
    components: {
        // leftSide,
        contents,
        analysis,
        filterSide,
        folderSide
    },
    created() {
        this.$store.commit('setMenuMini', false)
        this.id = this.$route.query.spaceId
        this.getInfo()
    },
    computed: {
        folderId() {
            return this.$store.state.folderId
        },
        spaceFilterData() {
            let data = []
            if(this.$store.state.spaceFilterData) {
                data = JSON.parse(this.$store.state.spaceFilterData)
            }
            return data
        }
    },
    watch: {
        folderId(val) {
            if(val) {
                this.getInfo()
            }
        },
        spaceFilterData(val) {
            this.fcKey = val
        },
        currentPage() {
            this.getInfo()
        }
    },
    methods: {
        ...mapActions('space',['spaceDetail']),
        filterChange(val) {
            this.fcKey = val
            this.getInfo()
        },
        secondFilter(val) {
            this.q2 = val
            this.getInfo()
        },
        getInfo() {
            if(this.showList.imageText) {
                this.pageSize = 10
            }else {
                this.pageSize = 30
            }
            let fcKey = this.fcKey?JSON.stringify(this.fcKey): ''
            let data = {
                params: {
                    wfId: this.folderId,
                    dm: 'mix',
                    p: this.currentPage,
                    ps: this.pageSize,
                    workspaceId: this.id,
                    q: '',
                    fc: fcKey,
                    q2: this.q2,
                    m: '',
                    ds: '',
                    s: this.sortKey
                }
            }
            let _this = this 
            this.spaceDetail({data: data,handle(res) {
                _this.data = res.pagination.data
                _this.total = res.pagination.total
                _this.detailInfo = res.workspace
                _this.length = Math.ceil(_this.total / _this.pageSize)
                window.scrollTo(0,0);
            }})
        },
        analyChange(val) {
            this.analyKey = val
            if(val == '专利分析') {
                // this.analysis = true
                // this.contents = false
                this.$router.push({
                    path: '/analyse/classify/all',
                    query: {
                        workspaceId: this.id,
                        folderId: this.folderId
                    }
                })
            }
            if(val =='3D专利地图分析') {
                this.$router.push({
                    path: '/workSpace/patentMap'
                })
            }
        },
        changeShow(val) {
            this.analyKey = ''
            this.contents = true
            this.analysis = false
            if(val=='tables') {
                this.showList = {
                    'tables': true,
                    'imageText': false,
                    'fullText': false
                }
            }
            if(val =='imageText') {
                this.showList = {
                    'tables': false,
                    'imageText': true,
                    'fullText': false
                }
            }
            if(val == 'fullText') {
                this.showList = {
                    'tables': false,
                    'imageText': false,
                    'fullText': true
                }
            }
            this.currentPage = 1
            this.getInfo()
        },
        goBack() {
            this.$router.push({
                path: '/workSpace/work'
            })
        },
        setShow() {
            this.dialog = true
        },
        move(val) {
            let list  = JSON.parse(JSON.stringify(this.chatNameList))
            list.forEach((item, index)=>{
                if(item.key == val.key) {
                    this.chatNameList.splice(index, 1);
                    this.chatNameList1.push(item)
                }
            })
        },
        move1(val) {
            let list  = JSON.parse(JSON.stringify(this.chatNameList1))
            list.forEach((item, index)=>{
                if(item.key == val.key) {
                    this.chatNameList1.splice(index, 1);
                    this.chatNameList.push(item)
                }
            })
        },
        sortChange() {
            this.getInfo()
        }
    }
}
</script>